// extracted by mini-css-extract-plugin
export var hideEditor = "_rw-2";
export var infoIcon = "_rw-3";
export var label = "_rw-1";
export var labelContainer = "_rw-0";
export var readonlyText = "_rw-4";